import { jsx } from 'react/jsx-runtime';
import 'react';

const MediumScrap = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M1.5 3.81592C1.5 2.12311 2.71753 0.299988 4.73138 0.299988H11.2809C11.3741 0.299988 11.4662 0.308689 11.556 0.325522C13.4025 0.494657 14.5 2.21541 14.5 3.82833V13.3502C14.5 15.2167 12.4259 16.3104 10.8622 15.3362L8 13.5532L5.13781 15.3362C3.57408 16.3104 1.5 15.2167 1.5 13.3502V3.81592Z",
            fill: "currentColor"
        }) : /*#__PURE__*/ jsx("path", {
            d: "M2.19995 3.81593C2.19995 2.39214 3.21201 1 4.73133 1H11.2808C11.3406 1 11.3994 1.00672 11.4561 1.01958C12.8706 1.12865 13.8 2.46396 13.8 3.82834V13.3502C13.8 14.648 12.3463 15.4361 11.2323 14.7421L7.99995 12.7285L4.76764 14.7421C3.65365 15.4361 2.19995 14.648 2.19995 13.3502V3.81593Z",
            stroke: "currentColor",
            strokeWidth: "1.4",
            strokeLinecap: "square",
            strokeLinejoin: "round"
        })
    });
};

export { MediumScrap as default };
